import "./Header.css";
import { MdMenu, MdClose } from "react-icons/md";
import { Link } from "react-router-dom";

interface HeaderProps {
  title: string;
  setShowMenu: () => void;
  showMenu?: boolean;
}

function Header({ title, setShowMenu, showMenu }: HeaderProps) {
  return (
    <div className="header-container">
      <Link to="/" className="header-daqtank-logo">
        DAQtank
      </Link>
      <h1 className="header-title">{title}</h1>
      <div className="mobile-menu">
        {showMenu ? (
          <MdClose
            className="menu-icon"
            onClick={setShowMenu}
            color="#4285F4" size={30}
          />
        ) : (
          <MdMenu className="menu-icon" onClick={setShowMenu} color="#4285F4" size={30} />
        )}
      </div>
    </div>
  );
}

export default Header;
